import { createReducer, MetaReducer, on } from '@ngrx/store';
import { userAuthenticated } from 'stores/auth/auth.actions';
import * as ResumeQuoteActions from 'stores/resume-quote/resume-quote.actions';
import * as QuoteControllerActions from 'sharedStores/quote-controller/quote-controller.actions';

export const authFeatureKey = 'auth';

export interface AuthState {
    token: string;
}

export const initialState: AuthState = {
    token: null,
};

export const reducers = createReducer(
    initialState,
    on(ResumeQuoteActions.reset, QuoteControllerActions.reset, (state) => ({
        ...initialState,
    })),
    on(userAuthenticated, (state, { token }) => {
        return { ...state, token: token };
    }),
);

export const metaReducers: MetaReducer<AuthState>[] = [];
